<template>
  <div class="f-news" v-show="areNewsPresent">
    <h2 class="title-container clickable" @click="loadNews">{{activeLanguage.news}}</h2>

    <div class="post-container">
      <!--<div class="wrapper">-->
        <!--<div class="masonry-container-new">-->
          <!--<div :key="index" class="brick"-->
               <!--v-for="(post, index) in news" :class="[{'card-mobile': $store.getters.isMobileValue}]">-->
            <!--<news-article-card :post-content="post"/>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

      <div :class="getContainerClass" v-masonry transition-duration="0.3s" item-selector=".item"  :fit-width="true">
        <div v-masonry-tile class="item" v-for="(post, index) in news" :key="index"
             :class="[{'card-mobile': $store.getters.isMobileValue}]">
          <news-article-card :post-content="post"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NewsPage from '../newsPageComponents/NewsPage'
  import NewsArticleCard from '../../utilComponents/NewsArticleCard'

  export default {
    name: 'News',
    components: {NewsArticleCard},
    data () {
      return {
        news: [],
        isSmallWindow: false
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      },
      areNewsPresent () {
        return this.news.length > 0
      },
      getContainerClass () {
        return this.isSmallWindow ? 'post-container-mobile' : 'post-container'
      }
    },
    methods: {
      loadNews () {
        this.$store.commit('setCurrentView', NewsPage)
        this.$router.push('/news')
      },
      fetchMostRecentNews () {
        let self = this
        this.$http.get(this.$PATH_NAME + 'news/getHighlights/').then((response) => {
          self.news = response.body
        })
      },
      checkWindowSize () {
        if ((!this.isSmallWindow) && window.innerWidth < 1051) {
          this.isSmallWindow = true
        } else if (this.isSmallWindow && window.innerWidth > 1051) {
          this.isSmallWindow = false
        }
      }
    },
    mounted () {
      this.fetchMostRecentNews()
      this.checkWindowSize()
      window.addEventListener('resize', () => this.checkWindowSize())
    }
  }
</script>

<style scoped>

  /*.f-news {*/
    /*!*background-color: whitesmoke;*!*/
    /*border-radius: 8px;*/
    /*height: 100%;*/
    /*padding: 3% 0 0;*/
  /*}*/

  .post-container {
    margin-bottom: 2%;
  }


  /*.post-container-mobile {*/
    /*width: 100% !important;*/
  /*}*/

  /*.card-mobile > a > div {*/
    /*max-width: 500px !important;*/
  /*}*/

  /*---------------------------------------------------------------*/
  /* Masonry grid */
  .masonry-container-new {
    transition: all .5s ease-in-out;
    column-gap: 0;
    column-fill: initial;
  }

  /* Masonry item */
  .masonry-container-new .brick {
    margin-bottom: 0;
    display: inline-block; /* Fix the misalignment of items */
    vertical-align: top; /* Keep the item on the very top */
  }

  /* Masonry image effects */
  .masonry-container-new .brick img {
    transition: all .5s ease-in-out;
    backface-visibility: hidden; /* Remove Image flickering on hover */
  }

  .masonry-container-new .brick:hover img {
    opacity: .75;
  }

  /* Masonry on tablets */
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    .masonry-container-new {
      column-count: 2;
    }
  }

  /* Masonry on big screens */
  @media only screen and (min-width: 1024px) {
    .desc {
      font-size: 1.25em;
    }

    .intro {
      letter-spacing: 1px;
    }

    .masonry-container-new {
      column-count: 3;
    }
  }

  .wrapper {
    margin-left: auto;
    margin-right: auto;
    /*padding-right: 1.5em;*/
    /*padding-left: 1.5em;*/
    max-width: 100%;
  }

  /*-----------------------------------------------------------------------*/

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/News.vue